<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-overlay :value="!loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <Strong>Note : If any data is not available or applicable, kindly mention NA</Strong></br>
    <Strong v-if="this.is_unicode_note == 'true' || this.is_unicode_note == true">टीप : कोणतीही माहिती उपलब्ध नसल्यास किंवा लागू नसल्यास, कृपया NA नमूद करा.</Strong>
    <v-form id="profile_form" @submit.prevent="submit" v-model="isValid" v-if="loader">
      <v-row dense justify="center">
        <v-col cols="10" sm="10" md="10">
          <input type="hidden" :value="application_form_data.admission_form_id" name="admission_form_id" /> </v-col>
      </v-row>
       <v-row dense justify="center" v-if="student_fullname != null">

        <v-col cols="10" sm="10" md="10">
          <v-icon color="error">*</v-icon>
          <v-text-field dense  v-model.trim="student_fullname" 
             :prepend-icon=" student_fullname != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined hint="Student Full Name" persistent-hint :readonly="is_allotment_standard"></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="firstname != null">

        <v-col cols="10" sm="10" md="10">
          <v-icon color="error">*</v-icon>
          <v-text-field dense  v-model.trim="firstname.field_value" :name="firstname.field_name" :required="true" @input="convertFullNameToUnicode" :rules="
              true
                ? [v => !!v || firstname.field_display_name + ' is required']
                : []
            " :clearable="firstname.required ? false : true" :prepend-icon="
              firstname.field_value != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined :hint=firstname.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="middlename != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="middlename.required">*</v-icon>
          <v-text-field dense v-model.trim="middlename.field_value" :name="middlename.field_name" @input="convertFullNameToUnicode"
            :required="middlename.required" :rules="
              middlename.required
                ? [v => !!v || middlename.field_display_name + ' is required']
                : []
            " :clearable="middlename.required ? false : true" :prepend-icon="
              middlename.field_value != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined :hint=middlename.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="lastname != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="lastname.required">*</v-icon>
          <v-text-field dense  v-model.trim="lastname.field_value" :name="lastname.field_name" :required="lastname.required" @input="convertFullNameToUnicode"
            :rules="
              lastname.required
                ? [v => !!v || lastname.field_display_name + ' is required']
                : []
            " :clearable="lastname.required ? false : true" :prepend-icon="
              lastname.field_value != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined :hint=lastname.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="unicode_student_name != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="unicode_student_name.required">*</v-icon>
          <v-text-field dense  v-model.trim="unicode_student_name.field_value" :name="unicode_student_name.field_name" :required="unicode_student_name.required"
            :rules="
              unicode_student_name.required
                ? [v => !!v || unicode_student_name.field_display_name + ' is required']
                : []
            " :clearable="unicode_student_name.required ? false : true" :prepend-icon="
              unicode_student_name.field_value != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined :hint=unicode_student_name.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="father_full_name != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="father_full_name.required">*</v-icon>
          <v-text-field  v-model.trim="father_full_name.field_value" :name="father_full_name.field_name"
            :required="father_full_name.required" :rules="
              father_full_name.required
                ? [
                    v =>
                      !!v ||
                      father_full_name.field_display_name + ' is required'
                  ]
                : []
            " :clearable="father_full_name.required ? false : true" :prepend-icon="
              father_full_name.field_value != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined :hint=father_full_name.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="mother_first_name != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="mother_first_name.required">*</v-icon>
          <v-text-field dense  v-model.trim="mother_first_name.field_value" :name="mother_first_name.field_name"
            :required="mother_first_name.required" :rules="
              mother_first_name.required
                ? [
                    v =>
                      !!v ||
                      mother_first_name.field_display_name + ' is required'
                  ]
                : []
            " :clearable="mother_first_name.required ? false : true" :prepend-icon="
              mother_first_name.field_value != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            " outlined :hint=mother_first_name.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if=" marital_status != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="marital_status.required">*</v-icon>

          <v-autocomplete dense v-model="marital_status.field_value" :items="marital_status.options"
            :name="marital_status.field_name" :required="marital_status.required" :rules="marital_status.required
                ? [
                  v =>
                    !!v ||
                    marital_status.field_display_name + ' is required'
                ]
                : []
              " :clearable="marital_status.required ? false : true" single-line prepend-icon="mdi-ring" outlined
            :hint="marital_status.field_display_name" persistent-hint>
          </v-autocomplete>

        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="gender != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="gender.required">*</v-icon>
          <v-autocomplete dense v-model="gender.field_value" :items="gender.options" item-text="name" item-value="id"
            :name="gender.field_name" :required="gender.required" :rules="
              gender.required
                ? [v => !!v || gender.field_display_name + ' is required']
                : []
            " :clearable="gender.required || is_allotment_standard ? false : true" return-object single-line
            prepend-icon="mdi-gender-male-female" outlined :hint=gender.field_display_name
            persistent-hint :readonly="is_allotment_standard"></v-autocomplete>
        </v-col>
      </v-row>
      <!-- Age -->
      <!-- Age: {{age_criterias}} -->
      <template v-if="age_criterias.length!=0 && tenant!='sbpps' && tenant!='eps'">
        <center>
          <v-row dense justify="center" align="center">
            <v-col cols="12" sm="3" md="3">
              <v-switch v-model="age_criteria_flag" label="Age criteria for new admission"></v-switch>
            </v-col>
          </v-row>
          <!-- age_criteria_flag -->
          <div style="width:30%">
            <v-simple-table v-if="age_criteria_flag && tenant!='sbpps' && tenant!='eps'" dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Class/Grade
                    </th>
                    <th class="text-left">
                      Dates between
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in age_criterias" :key="item.id">
                    <td v-if="standard.field_value==item.standard"><span style="color:red;font-weight:bold">{{
                        item.standard }}</span></td>
                    <td v-else>{{ item.standard }}</td>
                    <td v-if="standard.field_value==item.standard"><span style="color:red;font-weight:bold">{{
                        item.from_date }} to {{ item.to_date }}</span></td>
                    <td v-else>{{ item.from_date }} to {{ item.to_date }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </center>
      </template>

      <v-row dense justify="center" v-if="date_of_birth != null">
        <!-- <v-col cols="10" sm="10" md="10">
          <v-icon color="error">*</v-icon>
          <v-text-field outlined dense type="text" ref="dateInput"  v-model.trim="formattedDate"
            :name="date_of_birth.field_name" :hint="date_of_birth.field_display_name" persistent-hint
            prepend-icon="event" @click="openDatePicker" :required="date_of_birth.required"
            readonly></v-text-field>
          <input type="date" ref="realDateInput" v-model="date_of_birth.field_value" @input="convertDateToWords"
            style="opacity: 0; position: absolute; width: 1px; height: 1px;"/>
        </v-col> -->
                <v-col cols="10" sm="10" md="10">

          <v-icon color="error">*</v-icon>

          <div class="date-field-wrapper">

            <v-text-field
              outlined
              dense
              type="text"
              ref="dateInput"
              v-model="formattedDate"
              :name="date_of_birth.field_name"
              :hint="date_of_birth.field_display_name"
              persistent-hint
              prepend-icon="event"
              @click="openDatePicker"
              :required="date_of_birth.required"
              readonly
            ></v-text-field>

            <input
              type="date"
              ref="realDateInput"
              v-model="date_of_birth.field_value"
              @change="convertDateToWords"
              class="ios-date-input"
            />

          </div>

        </v-col>

        <!-- <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                dense
                v-model="date_of_birth.field_value"
                :name="date_of_birth.field_name"
                :hint= date_of_birth.field_display_name
                persistent-hint
                prepend-icon="event"
                @blur="convertDateToWords();"
                v-on="on"
                :required="date_of_birth.required"
                :rules="
                  date_of_birth.required
                    ? [
                        v =>
                          !!v ||
                          date_of_birth.field_display_name + ' is required'
                      ]
                    : []
                "
                outlined
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              no-title
               @input="menu1 = false; convertDateToWords();"
            ></v-date-picker>
          </v-menu> </v-col> -->
      </v-row>

      <v-row dense justify="center" v-if="date_of_birth_in_words!=null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="date_of_birth_in_words.required">*</v-icon>
          <v-text-field dense  v-model.trim="date_of_birth_in_words.field_value" :name="date_of_birth_in_words.field_name"
            :required="date_of_birth_in_words.required" :rules="
              date_of_birth_in_words.required
                ? [
                    v =>
                      !!v ||
                      date_of_birth_in_words.field_display_name + ' is required'
                  ]
                : []
            " :clearable="date_of_birth_in_words.required ? false : true" prepend-icon="event" outlined
            :hint=date_of_birth_in_words.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <!-- <v-row dense justify="center" v-if="standard != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error">*</v-icon>
          <v-autocomplete dense v-model="standard.field_value" :items="standard.options" :name="standard.field_name"
            :required="true" :rules="
              true
                ? [v => !!v || standard.field_display_name + ' is required']
                : []
            " :clearable="standard.required ? false : true" return-object single-line :prepend-icon="
              standard.field_value != null
                ? 'mdi-alpha-s-circle'
                : 'mdi-alpha-s-circle-outline'
            " outlined :hint=standard.field_display_name persistent-hint></v-autocomplete>
        </v-col>
      </v-row> -->

      <v-row dense justify="center" v-if="standard != null">
        <v-col cols="10" sm="10" md="10">

          <v-icon color="error">*</v-icon>

          <v-autocomplete
            dense
            v-model="standard.field_value"
            :items="standard.options"
            :name="standard.field_name"
            :required="true"
            :rules="[
              v => !!v || standard.field_display_name + ' is required'
            ]"
            :clearable="standard.required ? false : !is_allotment_standard"
            single-line
            outlined
            persistent-hint
            :hint="standard.field_display_name"
            :readonly="is_allotment_standard"
            :prepend-icon="
              standard.field_value != null
                ? 'mdi-alpha-s-circle'
                : 'mdi-alpha-s-circle-outline'
            "
          >
          </v-autocomplete>

        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="distance_from_school_to_home_in_km != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="distance_from_school_to_home_in_km.required">*</v-icon>
          <v-text-field dense  v-model.trim="distance_from_school_to_home_in_km.field_value"
            :name="distance_from_school_to_home_in_km.field_name" type="number"
            :required="distance_from_school_to_home_in_km.required" :rules="
              distance_from_school_to_home_in_km.required
                ? [
                    v =>
                      !!v || distance_from_school_to_home_in_km.field_display_name + ' is required'
                  ]
                : []
            " :clearable="distance_from_school_to_home_in_km.required ? false : true" :prepend-icon="
              distance_from_school_to_home_in_km.field_value != null
                ? 'mdi-alpha-d-circle'
                : 'mdi-alpha-d-circle-outline'
            " outlined :hint=distance_from_school_to_home_in_km.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="family_income != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="family_income.required">*</v-icon>
          <v-text-field dense  v-model.trim="family_income.field_value" :name="family_income.field_name" type="number"
            :required="family_income.required" :rules="
              family_income.required
                ? [
                    v =>
                      !!v || family_income.field_display_name + ' is required'
                  ]
                : []
            " :clearable="family_income.required ? false : true" :prepend-icon="
              family_income.field_value != null
                ? 'mdi-alpha-c-circle'
                : 'mdi-alpha-c-circle-outline'
            " outlined :hint=family_income.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="family_type != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="family_type.required">*</v-icon>
          <v-autocomplete dense v-model="family_type.field_value" :items="family_type.options"
            :name="family_type.field_name" :required="family_type.required" :rules="
              family_type.required
                ? [v => !!v || family_type.field_display_name + ' is required']
                : []
            " :clearable="family_type.required ? false : true" return-object single-line :prepend-icon="
              family_type.field_value != null
                ? 'mdi-flag'
                : 'mdi-flag-variant-outline'
            " outlined :hint=family_type.field_display_name persistent-hint></v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="birth_place != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="birth_place.required">*</v-icon>
          <v-text-field dense  v-model.trim="birth_place.field_value" :name="birth_place.field_name" @input="convertToUnicode(birth_place, unicode_birth_place)"
            :required="birth_place.required" :rules="
              birth_place.required
                ? [v => !!v || birth_place.field_display_name + ' is required']
                : []
            " :clearable="birth_place.required ? false : true" :hint=birth_place.field_display_name persistent-hint
            prepend-icon="mdi-home-map-marker" outlined></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="unicode_birth_place != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="unicode_birth_place.required">*</v-icon>
          <v-text-field dense  v-model.trim="unicode_birth_place.field_value" :name="unicode_birth_place.field_name"
            :required="unicode_birth_place.required" :rules="
              unicode_birth_place.required
                ? [v => !!v || unicode_birth_place.field_display_name + ' is required']
                : []
            " :clearable="unicode_birth_place.required ? false : true" :hint=unicode_birth_place.field_display_name persistent-hint
            prepend-icon="mdi-home-map-marker" outlined></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="birth_address != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="birth_address.required">*</v-icon>
          <v-text-field dense v-model.trim="birth_address.field_value" :name="birth_address.field_name"
            :required="birth_address.required" :rules="
              birth_address.required
                ? [
                    v =>
                      !!v || birth_address.field_display_name + ' is required'
                  ]
                : []
            " :clearable="birth_address.required ? false : true" prepend-icon="mdi-home-map-marker" outlined
            :hint=birth_address.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>


      <v-row dense justify="center" v-if="birthdistrict != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="birthdistrict.required">*</v-icon>
          <v-autocomplete dense v-model="birthdistrict.field_value" :items="birthdistrict.options"
            :name="birthdistrict.field_name" :required="birthdistrict.required" :rules="
              birthdistrict.required
                ? [v => !!v || birthdistrict.field_display_name + ' is required']
                : []
            " :clearable="birthdistrict.required ? false : true" return-object single-line :prepend-icon="
              birthdistrict.field_value != null
                ? 'mdi-flag'
                : 'mdi-flag-variant-outline'
            " outlined :hint=birthdistrict.field_display_name persistent-hint></v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="birthtaluka != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="birthtaluka.required">*</v-icon>
          <v-text-field dense  v-model.trim="birthtaluka.field_value" :name="birthtaluka.field_name" @input="convertToUnicode(birthtaluka, unicodebirthtaluka)"
            :required="birthtaluka.required" :rules="
              birthtaluka.required
                ? [v => !!v || birthtaluka.field_display_name + ' is required']
                : []
            " :clearable="birthtaluka.required ? false : true" :hint=birthtaluka.field_display_name persistent-hint
            prepend-icon="mdi-home-map-marker" outlined></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="unicodebirthtaluka != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="unicodebirthtaluka.required">*</v-icon>
          <v-text-field dense  v-model.trim="unicodebirthtaluka.field_value" :name="unicodebirthtaluka.field_name"
            :required="unicodebirthtaluka.required" :rules="
              unicodebirthtaluka.required
                ? [v => !!v || unicodebirthtaluka.field_display_name + ' is required']
                : []
            " :clearable="unicodebirthtaluka.required ? false : true" :hint=unicodebirthtaluka.field_display_name persistent-hint
            prepend-icon="mdi-home-map-marker" outlined></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="birthcountry != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="birthcountry.required">*</v-icon>
          <v-autocomplete dense v-model="birthcountry.field_value" :items="birthcountry.options"
            :name="birthcountry.field_name" :required="birthcountry.required" :rules="
              birthcountry.required
                ? [v => !!v || birthcountry.field_display_name + ' is required']
                : []
            " :clearable="birthcountry.required ? false : true" return-object single-line :prepend-icon="
              birthcountry.field_value != null
                ? 'mdi-flag'
                : 'mdi-flag-variant-outline'
            " outlined :hint=birthcountry.field_display_name persistent-hint></v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="birthcity != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="birthcity.required">*</v-icon>
          <v-autocomplete dense v-model="birthcity.field_value" :items="birthcity.options" :name="birthcity.field_name"
            :required="birthcity.required" :rules="
              birthcity.required
                ? [v => !!v || birthcity.field_display_name + ' is required']
                : []
            " :clearable="birthcity.required ? false : true" return-object single-line :prepend-icon="
              birthcity.field_value != null
                ? 'mdi-flag'
                : 'mdi-flag-variant-outline'
            " outlined :hint=birthcity.field_display_name persistent-hint></v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="birthstate != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="birthstate.required">*</v-icon>
          <v-autocomplete dense v-model="birthstate.field_value" :items="birthstate.options"
            :name="birthstate.field_name" :required="birthstate.required" :rules="
              birthstate.required
                ? [v => !!v || birthstate.field_display_name + ' is required']
                : []
            " :clearable="birthstate.required ? false : true" return-object single-line :prepend-icon="
              birthstate.field_value != null
                ? 'mdi-flag'
                : 'mdi-flag-variant-outline'
            " outlined :hint=birthstate.field_display_name persistent-hint></v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="nationality != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="nationality.required">*</v-icon>
          <v-autocomplete dense v-model="nationality.field_value" :items="nationality.options"
            :name="nationality.field_name" :required="nationality.required" :rules="
              nationality.required
                ? [v => !!v || nationality.field_display_name + ' is required']
                : []
            " :clearable="nationality.required ? false : true" return-object single-line :prepend-icon="
              nationality.field_value != null
                ? 'mdi-flag'
                : 'mdi-flag-variant-outline'
            " outlined :hint=nationality.field_display_name persistent-hint></v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="bloodgroup != null && tenant!='sbpps'">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="bloodgroup.required">*</v-icon>
          <v-autocomplete dense v-model="bloodgroup.field_value" :items="bloodgroup.options"
            :name="bloodgroup.field_name" :required="bloodgroup.required" :rules="
              bloodgroup.required
                ? [v => !!v || bloodgroup.field_display_name + ' is required']
                : []
            " :clearable="bloodgroup.required ? false : true" single-line prepend-icon="mdi-blood-bag" outlined
            :hint=bloodgroup.field_display_name persistent-hint></v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="category != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="category.required">*</v-icon>
          <v-autocomplete dense v-model="category.field_value" :items="category.options" :name="category.field_name"
            :required="category.required" :rules="
              category.required
                ? [v => !!v || category.field_display_name + ' is required']
                : []
            " :clearable="category.required || is_allotment_standard === true ? false : true" single-line :prepend-icon="
              category.field_value != null
                ? 'mdi-alpha-c-circle'
                : 'mdi-alpha-c-circle-outline'
            " outlined :hint=category.field_display_name persistent-hint :readonly="is_allotment_standard"></v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="religion != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="religion.required">*</v-icon>
          <v-autocomplete dense v-model="religion.field_value" :items="religion.options" :name="religion.field_name"
            :required="religion.required" :rules="
              religion.required
                ? [v => !!v || religion.field_display_name + ' is required']
                : []
            " :clearable="religion.required ? false : true" single-line :prepend-icon="
              religion.field_value != null
                ? 'mdi-alpha-r-circle'
                : 'mdi-alpha-r-circle-outline'
            " outlined :hint=religion.field_display_name persistent-hint></v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="cast != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="cast.required">*</v-icon>
          <v-autocomplete dense v-model="cast.field_value" :items="cast.options" :name="cast.field_name"
            :required="cast.required" :rules="
              cast.required
                ? [v => !!v || cast.field_display_name + ' is required']
                : []
            " :clearable="cast.required ? false : true" single-line :prepend-icon="
              cast.field_value != null
                ? 'mdi-alpha-c-circle'
                : 'mdi-alpha-c-circle-outline'
            " outlined :hint=cast.field_display_name persistent-hint></v-autocomplete>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="sub_caste != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="sub_caste.required">*</v-icon>
          <v-autocomplete dense v-model="sub_caste.field_value" :items="sub_caste.options" :name="sub_caste.field_name"
            :required="sub_caste.required" :rules="
              sub_caste.required
                ? [v => !!v || sub_caste.field_display_name + ' is required']
                : []
            " :clearable="sub_caste.required ? false : true" single-line :prepend-icon="
              sub_caste.field_value != null
                ? 'mdi-alpha-c-circle'
                : 'mdi-alpha-c-circle-outline'
            " outlined :hint=sub_caste.field_display_name persistent-hint></v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="mothertoungue != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="mothertoungue.required">*</v-icon>
          <v-autocomplete dense v-model="mothertoungue.field_value" :items="mothertoungue.options"
            :name="mothertoungue.field_name" :required="mothertoungue.required" :rules="
              mothertoungue.required
                ? [
                    v =>
                      !!v || mothertoungue.field_display_name + ' is required'
                  ]
                : []
            " :clearable="mothertoungue.required ? false : true" single-line :prepend-icon="
              mothertoungue.field_value != null
                ? 'mdi-alpha-m-circle'
                : 'mdi-alpha-m-circle-outline'
            " outlined :hint=mothertoungue.field_display_name persistent-hint></v-autocomplete>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="second_language_currently_studying != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="second_language_currently_studying.required">*</v-icon>
          <v-text-field dense  v-model.trim="second_language_currently_studying.field_value"
            :name="second_language_currently_studying.field_name" type="text" :prepend-icon="
              second_language_currently_studying.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            " outlined :required="second_language_currently_studying.required" :rules="
              second_language_currently_studying.required
                ? [
                    v =>
                      !!v || second_language_currently_studying.field_display_name + ' is required'
                  ]
                : []
            " :clearable="second_language_currently_studying.required ? false : true"
            :hint=second_language_currently_studying.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="ration_card_color != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="ration_card_color.required">*</v-icon>
          <v-autocomplete dense v-model="ration_card_color.field_value" :items="ration_card_color.options"
            :name="ration_card_color.field_name" :required="ration_card_color.required" :rules="
              ration_card_color.required
                ? [v => !!v || ration_card_color.field_display_name + ' is required']
                : []
            " :clearable="ration_card_color.required ? false : true" single-line :prepend-icon="
              ration_card_color.field_value != null
                ? 'mdi-alpha-c-circle'
                : 'mdi-alpha-c-circle-outline'
            " outlined :hint=ration_card_color.field_display_name persistent-hint></v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="tenant == 'uwws'">
        <v-col cols="10" sm="10" md="10">
          <v-radio-group v-model="idType" name="isaadhar" row @change="updateRequiredFields">
            <v-radio label="Aadhar No." value="aadhar"></v-radio>
            <v-radio label="Passport No." value="passport"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <!-- Aadhar Field (Visible Only When 'Aadhar No.' is Selected) -->
      <v-row dense justify="center" v-if="idType === 'aadhar' && aadhar_no && tenant == 'uwws'">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="aadhar_no.required">*</v-icon>
          <v-text-field dense  v-model.trim="aadhar_no.field_value" :name="aadhar_no.field_name" type="number"
            :required="aadhar_no.required" :rules="
          aadhar_no.required
            ? [
                v => !!v || aadhar_no.field_display_name + ' is required',
                v =>
                  (v && v.length == 12) ||
                  aadhar_no.field_display_name + ' must be a 12-digit number'
              ]
            : [
                v =>
                  (v == null || v == ''
                    ? true
                    : v.length == 0 || v.length == 12) ||
                  aadhar_no.field_display_name + ' must be a 12-digit number'
              ]
        " counter maxlength="12" :clearable="!aadhar_no.required" :prepend-icon="
          aadhar_no.field_value
            ? 'mdi-alpha-a-circle'
            : 'mdi-alpha-a-circle-outline'
        " outlined :hint="aadhar_no.field_display_name" persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <!-- Passport Field (Visible Only When 'Passport No.' is Selected) -->
      <v-row dense justify="center" v-if="idType === 'passport' && passport_no && tenant == 'uwws'">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="passport_no.required">*</v-icon>
          <v-text-field dense  v-model.trim="passport_no.field_value" :name="passport_no.field_name" type="text"
            :required="passport_no.required" :clearable="!passport_no.required" :prepend-icon="
          passport_no.field_value
            ? 'mdi-alpha-a-circle'
            : 'mdi-alpha-a-circle-outline'
        " outlined :hint="passport_no.field_display_name" persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="aadhar_no != null && tenant != 'uwws'">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="aadhar_no.required">*</v-icon>
          <v-text-field dense  v-model.trim="aadhar_no.field_value" :name="aadhar_no.field_name" type="text"
            :required="aadhar_no.required"
            :rules=" aadhar_no.required 
              ? [
                  v => !!v || aadhar_no.field_display_name + ' is required',
                  v => /^\d{12}$/.test(v) || aadhar_no.field_display_name + ' must be 12 digit number'
                ] 
              : [
                  v => !v || /^\d{12}$/.test(v) || aadhar_no.field_display_name + ' must be 12 digit number'
                ] 
            "
            counter maxlength="12" :clearable="aadhar_no.required ? false : true" :prepend-icon="
              aadhar_no.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            " outlined :hint=aadhar_no.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="passport_no != null && tenant != 'uwws'">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="passport_no.required">*</v-icon>
          <v-text-field dense  v-model.trim="passport_no.field_value" :name="passport_no.field_name" type="text"
            :required="passport_no.required" :clearable="passport_no.required ? false : true" :prepend-icon="
              passport_no.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            " outlined :hint=passport_no.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="name_as_aadhar_card != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="name_as_aadhar_card.required">*</v-icon>
          <v-text-field dense  v-model.trim="name_as_aadhar_card.field_value" :name="name_as_aadhar_card.field_name"
            type="text" :required="name_as_aadhar_card.required"
            :clearable="name_as_aadhar_card.required ? false : true" :prepend-icon="
              name_as_aadhar_card.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            " outlined :hint=name_as_aadhar_card.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="pen_no != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="pen_no.required">*</v-icon>
          <v-text-field dense  v-model.trim="pen_no.field_value" :name="pen_no.field_name" type="text"
            :required="pen_no.required"
            :rules="
              pen_no.required
                ? [
                    v => !!v || pen_no.field_display_name + ' is required',
                    v => /^\d{11}$/.test(v) || pen_no.field_display_name + ' must be 11 digit number'
                  ]
                : [
                    v =>
                      !v || /^\d{11}$/.test(v) ||
                      pen_no.field_display_name + ' must be 11 digit number'
                  ]
            "
            counter maxlength="11" :clearable="pen_no.required ? false : true" :prepend-icon="
              pen_no.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            " outlined :hint=pen_no.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="saral_id != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="saral_id.required">*</v-icon>
          <v-text-field dense  v-model.trim="saral_id.field_value" :name="saral_id.field_name" type="text"
            :required="saral_id.required" :rules="
              saral_id.required
                ? [
                    v => !!v || saral_id.field_display_name + ' is required',
                    v =>
                      (v && v.length == 19) ||
                      saral_id.field_display_name + ' must be 19 digit number'
                  ]
                : [
                    v =>
                      (v == null || v == ''
                        ? true
                        : v.length == 0 || v.length == 19) ||
                      saral_id.field_display_name + ' must be 19 digit number'
                  ]
            " counter maxlength="19" :clearable="saral_id.required ? false : true" :prepend-icon="
              saral_id.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            " outlined :hint=saral_id.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="udise_national_code != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="udise_national_code.required">*</v-icon>
          <v-text-field dense  v-model.trim="udise_national_code.field_value" :name="udise_national_code.field_name"
            type="text" :required="udise_national_code.required"
            :clearable="udise_national_code.required ? false : true" :prepend-icon="
              udise_national_code.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            " outlined :hint=udise_national_code.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="citizenship != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="citizenship.required">*</v-icon>
          <v-text-field dense  v-model.trim="citizenship.field_value" :name="citizenship.field_name" type="text"
            :prepend-icon="
              citizenship.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            " outlined :required="citizenship.required" :rules="
              citizenship.required
                ? [
                    v =>
                      !!v || citizenship.field_display_name + ' is required'
                  ]
                : []
            " :clearable="citizenship.required ? false : true" :hint=citizenship.field_display_name
            persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="academic_program_studied != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="academic_program_studied.required">*</v-icon>
          <v-text-field dense  v-model.trim="academic_program_studied.field_value" :name="academic_program_studied.field_name"
            type="text" :prepend-icon="
              academic_program_studied.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            " outlined :required="academic_program_studied.required" :rules="
              academic_program_studied.required
                ? [
                    v =>
                      !!v || academic_program_studied.field_display_name + ' is required'
                  ]
                : []
            " :clearable="academic_program_studied.required ? false : true"
            :hint=academic_program_studied.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="languages_known != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="languages_known.required">*</v-icon>
          <v-autocomplete dense v-model="languages_known.field_value" :items="languages_known.options" single-line
            multiple :clearable="true" :prepend-icon="
              languages_known.field_value != null
                ? 'mdi-alpha-l-circle'
                : 'mdi-alpha-l-circle-outline'
            " :rules="
              languages_known.required
                ? [v => v.length!=0 || languages_known.field_display_name + ' is required']
                : []
            " :hint=languages_known.field_display_name persistent-hint outlined></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="8" md="8" v-show="false">
          <v-icon color="error" v-if="languages_known.required">*</v-icon>
          <v-text-field dense  v-model.trim="languages_known.field_value" :name="languages_known.field_name"
            readonly></v-text-field>
        </v-col>

      </v-row>

      <v-row dense justify="center" v-if="sibling_details != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="sibling_details.required">*</v-icon>
          <v-text-field dense  v-model.trim="sibling_details.field_value" :name="sibling_details.field_name"
            :required="sibling_details.required" :rules="
              sibling_details.required
                ? [
                    v =>
                      !!v ||
                      'Sibling Details [Name:Vikas Std: V] is required'
                  ]
                : []
            " counter :clearable="sibling_details.required ? false : true" :prepend-icon="
              sibling_details.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            " outlined :hint=sibling_details.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="domacile != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="domacile.required">*</v-icon>
          <v-autocomplete dense v-model="domacile.field_value" :items="domacile.options" :name="domacile.field_name"
            :required="domacile.required" :rules="
              domacile.required
                ? [v => !!v || domacile.field_display_name + ' is required']
                : []
            " :clearable="domacile.required ? false : true" single-line :hint=domacile.field_display_name
            persistent-hint :prepend-icon="
              domacile.field_value != null
                ? 'mdi-alpha-d-circle'
                : 'mdi-alpha-d-circle-outline'
            " outlined></v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="isphysicallyhandicapped != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="isphysicallyhandicapped.required">*</v-icon>
          <v-autocomplete dense v-model="isphysicallyhandicapped.field_value" :items="isphysicallyhandicapped.options"
            :name="isphysicallyhandicapped.field_name" :required="isphysicallyhandicapped.required" :rules="
              isphysicallyhandicapped.required
                ? [
                    v =>
                      !!v ||
                      isphysicallyhandicapped.field_display_name +
                        ' is required'
                  ]
                : []
            " :clearable="isphysicallyhandicapped.required ? false : true"
            :hint=isphysicallyhandicapped.field_display_name persistent-hint single-line
            prepend-icon="mdi-seat-passenger" outlined></v-autocomplete>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="is_cast_certificate_available != null">
        <v-col cols="10" sm="10" md="10">
          <v-autocomplete dense v-model="is_cast_certificate_available.field_value"
            :items="is_cast_certificate_available.options" :name="is_cast_certificate_available.field_name"
            :required="is_cast_certificate_available.required"
            :clearable="is_cast_certificate_available.required ? false : true"
            :hint=is_cast_certificate_available.field_display_name persistent-hint single-line
            prepend-icon="mdi mdi-file-certificate-outline" outlined></v-autocomplete>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="is_bpl_beneficiary != null">
        <v-col cols="10" sm="10" md="10">
          <v-autocomplete dense v-model="is_bpl_beneficiary.field_value" :items="is_bpl_beneficiary.options"
            :name="is_bpl_beneficiary.field_name" :required="is_bpl_beneficiary.required"
            :clearable="is_bpl_beneficiary.required ? false : true" :hint=is_bpl_beneficiary.field_display_name
            persistent-hint single-line prepend-icon="mdi mdi-card-text" outlined></v-autocomplete>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="minority != null">
        <v-col cols="10" sm="10" md="10">
          <v-autocomplete dense v-model="minority.field_value" :items="minority.options" :name="minority.field_name"
            :required="minority.required" :clearable="minority.required ? false : true" single-line :prepend-icon="
              minority.field_value != null
                ? 'mdi-alpha-m-circle'
                : 'mdi-alpha-m-circle-outline'
            " outlined :hint=minority.field_display_name persistent-hint></v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="special_education_needs != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="special_education_needs.required">*</v-icon>
          <v-text-field dense  v-model.trim="special_education_needs.field_value" :name="special_education_needs.field_name"
            :required="special_education_needs.required" :rules="
              special_education_needs.required
                ? [
                    v =>
                      !!v ||
                      'Special Education Is Required'
                  ]
                : []
            " counter :clearable="special_education_needs.required ? false : true" :prepend-icon="
              special_education_needs.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            " outlined :hint=special_education_needs.field_display_name persistent-hint></v-text-field>
        </v-col>

    
      </v-row>

      <v-row dense justify="center" v-if="physicallyhandicapped_details != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="physicallyhandicapped_details.required">*</v-icon>
          <v-textarea dense :value="physicallyhandicapped_details.field_value"
            v-model="physicallyhandicapped_details.field_value" :name="physicallyhandicapped_details.field_name"
            :required="physicallyhandicapped_details.required" :rules="
              physicallyhandicapped_details.required
                ? [
                    v =>
                      !!v || 'Physically handicapped details is required'
                  ]
                : []
            " :clearable="physicallyhandicapped_details.required ? false : true"
            :hint=physicallyhandicapped_details.field_display_name persistent-hint :prepend-icon="
              physicallyhandicapped_details.field_value != null
                ? 'mdi-hospital-box'
                : 'mdi-hospital-box-outline'
            " outlined></v-textarea>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="medical_problem != null && tenant!='sbpps'">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="medical_problem.required">*</v-icon>
          <v-textarea dense :value="medical_problem.field_value" v-model="medical_problem.field_value"
            :name="medical_problem.field_name" :required="medical_problem.required" :rules="
              medical_problem.required
                ? [
                    v =>
                      !!v || medical_problem.field_display_name + ' is required'
                  ]
                : []
            " :clearable="medical_problem.required ? false : true" :hint=medical_problem.field_display_name
            persistent-hint :prepend-icon="
              medical_problem.field_value != null
                ? 'mdi-hospital-box'
                : 'mdi-hospital-box-outline'
            " outlined></v-textarea>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="medication != null && tenant!='sbpps'">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="medication.required">*</v-icon>
          <v-textarea dense :value="medication.field_value" v-model="medication.field_value"
            :name="medication.field_name" :required="medication.required" :rules="
              medication.required
                ? [
                    v =>
                      !!v || medication.field_display_name + ' is required'
                  ]
                : []
            " :clearable="medication.required ? false : true" :hint=medication.field_display_name persistent-hint
            :prepend-icon="
              medication.field_value != null
                ? 'mdi-hospital-box'
                : 'mdi-hospital-box-outline'
            " outlined></v-textarea>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="allergy != null && tenant!='sbpps'">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="allergy.required">*</v-icon>
          <v-textarea dense :value="allergy.field_value" v-model="allergy.field_value" :name="allergy.field_name"
            :required="allergy.required" :rules="
              allergy.required
                ? [
                    v =>
                      !!v || allergy.field_display_name + ' is required'
                  ]
                : []
            " :clearable="allergy.required ? false : true" :hint=allergy.field_display_name persistent-hint
            :prepend-icon="
              allergy.field_value != null
                ? 'mdi-hospital-box'
                : 'mdi-hospital-box-outline'
            " outlined></v-textarea>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="specific_qualities != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="specific_qualities.required">*</v-icon>
          <v-textarea dense :value="specific_qualities.field_value" v-model="specific_qualities.field_value"
            :name="specific_qualities.field_name" :required="specific_qualities.required" :rules="
              specific_qualities.required
                ? [
                    v =>
                      !!v || specific_qualities.field_display_name + ' is required'
                  ]
                : []
            " :clearable="specific_qualities.required ? false : true" :hint=specific_qualities.field_display_name
            persistent-hint :prepend-icon="
              specific_qualities.field_value != null
                ? 'mdi-hospital-box'
                : 'mdi-hospital-box-outline'
            " outlined></v-textarea>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="significant_information != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="significant_information.required">*</v-icon>
          <v-textarea dense :value="significant_information.field_value" v-model="significant_information.field_value"
            :name="significant_information.field_name" :required="significant_information.required" :rules="
              significant_information.required
                ? [
                    v =>
                      !!v || significant_information.field_display_name + ' is required'
                  ]
                : []
            " :clearable="significant_information.required ? false : true"
            :hint=significant_information.field_display_name persistent-hint :prepend-icon="
              significant_information.field_value != null
                ? 'mdi-hospital-box'
                : 'mdi-hospital-box-outline'
            " outlined></v-textarea>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="is_single_girl_child != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="is_single_girl_child.required">*</v-icon>
          <v-autocomplete dense v-model="is_single_girl_child.field_value" :items="is_single_girl_child.options"
            :name="is_single_girl_child.field_name" :required="is_single_girl_child.required" :rules="
              is_single_girl_child.required
                ? [
                    v =>
                      !!v ||
                      is_single_girl_child.field_display_name +
                        ' is required'
                  ]
                : []
            " :clearable="is_single_girl_child.required ? false : true" :hint=is_single_girl_child.field_display_name
            persistent-hint single-line prepend-icon="mdi-account-question" outlined></v-autocomplete>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="is_EWS != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="is_EWS.required">*</v-icon>
          <v-autocomplete dense v-model="is_EWS.field_value" :items="is_EWS.options" :name="is_EWS.field_name"
            :required="is_EWS.required" :rules="
              is_EWS.required
                ? [
                    v =>
                      !!v ||
                      is_EWS.field_display_name +
                        ' is required'
                  ]
                : []
            " :clearable="is_EWS.required ? false : true" :hint=is_EWS.field_display_name persistent-hint single-line
            prepend-icon="mdi-account-question" outlined></v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="height_in_cm != null && tenant!='sbpps'">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="height_in_cm.required">*</v-icon>
          <v-text-field dense  v-model.trim="height_in_cm.field_value" :name="height_in_cm.field_name" type="number"
            :required="height_in_cm.required" :clearable="height_in_cm.required ? false : true" :prepend-icon="
              height_in_cm.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            " outlined :hint=height_in_cm.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="weight_in_kg != null && tenant!='sbpps'">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="weight_in_kg.required">*</v-icon>
          <v-text-field dense  v-model.trim="weight_in_kg.field_value" :name="weight_in_kg.field_name" type="number"
            :required="weight_in_kg.required" :clearable="weight_in_kg.required ? false : true" :prepend-icon="
              weight_in_kg.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            " outlined :hint=weight_in_kg.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="shift != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="shift.required">*</v-icon>
          <v-autocomplete dense v-model="shift.field_value" :items="shift.options" item-text="name" item-value="id"
            :name="shift.field_name" :required="shift.required" :rules="
              shift.required
                ? [v => !!v || shift.field_display_name + ' is required']
                : []
            " :clearable="shift.required ? false : true" return-object single-line
            prepend-icon="mdi-clock-outline" outlined :hint=shift.field_display_name
            persistent-hint></v-autocomplete>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="mediumofinstruction != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="mediumofinstruction.required">*</v-icon>
          <v-autocomplete dense v-model="mediumofinstruction.field_value" :items="mediumofinstruction.options"
            item-text="name" item-value="id" :name="mediumofinstruction.field_name"
            :required="mediumofinstruction.required" :rules="
              mediumofinstruction.required
                ? [v => !!v || mediumofinstruction.field_display_name + ' is required']
                : []
            " :clearable="mediumofinstruction.required ? false : true" return-object single-line
            prepend-icon="mdi-gender-male-female" outlined :hint=mediumofinstruction.field_display_name
            persistent-hint></v-autocomplete>
        </v-col>
      </v-row>

      <!-- FOR ZEAL -->
      <v-row dense justify="center" v-if="reference != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="reference.required">*</v-icon>
          <v-text-field dense :value="reference.field_value" v-model.trim="reference.field_value"
            :name="reference.field_name" :required="reference.required" :rules="
              reference.required
                ? [
                    v =>
                      !!v || reference.field_display_name + ' is required'
                  ]
                : []
            " :clearable="reference.required ? false : true" :hint=reference.field_display_name persistent-hint
            :prepend-icon="
              reference.field_value != null
                ? 'mdi-hospital-box'
                : 'mdi-hospital-box-outline'
            " outlined></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="entrance_exam_marks != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="entrance_exam_marks.required">*</v-icon>
          <v-text-field dense  v-model.trim="entrance_exam_marks.field_value" :name="entrance_exam_marks.field_name"
            type="number" :required="entrance_exam_marks.required"
            :clearable="entrance_exam_marks.required ? false : true" :prepend-icon="
              entrance_exam_marks.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            " outlined :hint=entrance_exam_marks.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="age_on_first_june != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="age_on_first_june.required">*</v-icon>
          <v-text-field dense  v-model.trim="age_on_first_june.field_value" :name="age_on_first_june.field_name" type="number"
            :required="age_on_first_june.required" :clearable="age_on_first_june.required ? false : true" :prepend-icon="
              age_on_first_june.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            " outlined :hint=age_on_first_june.field_display_name persistent-hint></v-text-field>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="interested_in_sports != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="interested_in_sports.required">*</v-icon>
          <v-autocomplete dense v-model="interested_in_sports.field_value" :items="interested_in_sports.options"
            :name="interested_in_sports.field_name" :required="interested_in_sports.required" :rules="
              interested_in_sports.required
                ? [
                    v =>
                      !!v ||
                      interested_in_sports.field_display_name +
                        ' is required'
                  ]
                : []
            " :clearable="interested_in_sports.required ? false : true" :hint=interested_in_sports.field_display_name
            persistent-hint single-line prepend-icon="mdi-account-question" outlined></v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="hostel != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="hostel.required">*</v-icon>
          <v-autocomplete dense v-model="hostel.field_value" :items="hostel.options" :name="hostel.field_name"
            :required="hostel.required" :rules="
              hostel.required
                ? [
                    v =>
                      !!v ||
                      hostel.field_display_name +
                        ' is required'
                  ]
                : []
            " :clearable="hostel.required ? false : true" :hint=hostel.field_display_name persistent-hint single-line
            prepend-icon="mdi-account-question" outlined></v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="factors_contributed_for_admission_decision != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="factors_contributed_for_admission_decision.required">*</v-icon>
          <v-textarea dense :value="factors_contributed_for_admission_decision.field_value"
            v-model="factors_contributed_for_admission_decision.field_value"
            :name="factors_contributed_for_admission_decision.field_name"
            :required="factors_contributed_for_admission_decision.required" :rules="
              factors_contributed_for_admission_decision.required
                ? [
                    v =>
                      !!v || factors_contributed_for_admission_decision.field_display_name + ' is required'
                  ]
                : []
            " :clearable="factors_contributed_for_admission_decision.required ? false : true"
            :hint=factors_contributed_for_admission_decision.field_display_name persistent-hint :prepend-icon="
              factors_contributed_for_admission_decision.field_value != null
                ? 'mdi-hospital-box'
                : 'mdi-hospital-box-outline'
            " outlined></v-textarea>
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="is_orphan != null">
        <v-col cols="10" sm="10" md="10">
          
          <v-icon color="error" v-if="is_orphan.required">*</v-icon>

          <v-autocomplete
            dense
             v-model="is_orphan.field_value"
            :items="is_orphan.options"
            :name="is_orphan.field_name"
            :required="is_orphan.required"
            :rules="is_orphan.required
              ? [v => !!v || is_orphan.field_display_name + ' is required']
              : []"
            :clearable="!is_orphan.required"
            :hint="is_orphan.field_display_name"
            persistent-hint
            prepend-icon="mdi-help-circle"
            outlined
          />
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="eligibility_no != null">
        <v-col cols="10" sm="10" md="10">

          <v-icon color="error" v-if="eligibility_no.required">*</v-icon>

          <v-text-field
            dense
            v-model.trim="eligibility_no.field_value"
            :name="eligibility_no.field_name"
            :required="eligibility_no.required"
            :clearable="!eligibility_no.required"
            :rules="eligibility_no.required
              ? [v => !!v || eligibility_no.field_display_name + ' is required']
              : []"
            :hint="eligibility_no.field_display_name"
            persistent-hint
            :prepend-icon="
              eligibility_no.field_value != null
                ? 'mdi-alpha-e-circle'
                : 'mdi-alpha-e-circle-outline'"
            outlined
          />
        </v-col>
      </v-row>

      <v-row dense justify="center" v-if="is_social_welfare_required != null">
  <v-col cols="10" sm="10" md="10">

    <v-icon color="error"
      v-if="is_social_welfare_required.required">*</v-icon>

    <v-autocomplete
      dense
      v-model="is_social_welfare_required.field_value"
      :items="is_social_welfare_required.options"
      :name="is_social_welfare_required.field_name"
      :required="is_social_welfare_required.required"
      :rules="
        is_social_welfare_required.required
          ? [
              v =>
                !!v ||
                is_social_welfare_required.field_display_name + ' is required'
            ]
          : []
      "
      :clearable="
        is_social_welfare_required.required ? false : true
      "
      single-line
      prepend-icon="mdi-account-question"
      outlined
      :hint="is_social_welfare_required.field_display_name"
      persistent-hint
    >
    </v-autocomplete>

  </v-col>
</v-row>

<v-row
  dense
  justify="center"
  v-if="
    socialwelfare != null &&
    is_social_welfare_required.field_value == 'Yes'
  "
>
  <v-col cols="10" sm="10" md="10">

    <v-icon color="error" v-if="socialwelfare.required">*</v-icon>

    <v-autocomplete
      dense
      v-model="socialwelfare.field_value"
      :items="socialwelfare.options"
      :name="socialwelfare.field_name"
      :required="socialwelfare.required"
      :rules="
        socialwelfare.required
          ? [
              v =>
                !!v ||
                socialwelfare.field_display_name + ' is required'
            ]
          : []
      "
      :clearable="socialwelfare.required ? false : true"
      single-line
      prepend-icon="mdi-school"
      outlined
      :hint="socialwelfare.field_display_name"
      persistent-hint
    >
    </v-autocomplete>

  </v-col>
</v-row>
      <!-- FOR ZEAL -->

      <v-row justify="center" dense>
        <v-col cols="10" sm="10" md="10">
          <div style="text-align:center">
            <v-btn class="mt-2" :color="isValid ? 'primary darken-1' : 'grey lighten-1'" @click="submit"
              :disabled="!isValid">Save</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    data() {
      return {
        isNRIStudent: false,
        idType: 'aadhar',
        isValid: true,
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        application_form_data: {
          admission_form_no: "",
          admission_form_id: "",
          display_admission_form_no: ""
        },

        //profile
        firstname: {
          field_value: ""
        },
        lastname: {
          field_value: ""
        },
        middlename: {
          field_value: ""
        },
        mother_first_name: {
          field_value: ""
        },
        father_full_name: {
          field_value: ""
        },
        gender: {},
        shift: {},
        mediumofinstruction: {},
        family_income: {},
        standard: {},
        birth_place: {},
        birth_address: {},
        birthcountry: {},
        unicode_birth_place: {},
        birthdistrict: {},
        birthtaluka: {},
        unicodebirthtaluka: {},
        birthcity: {},
        birthstate: {},
        family_type: {},
        nationality: {},
        date_of_birth: {
          field_value: "",
          field_name: "dob",
          field_display_name: "Date of Birth",
        },
        date_of_birth_in_words: {
          field_value: "",
          field_name: "dob_in_words",
          field_display_name: "Date of Birth (in words)",
        },
        application_form_no: 0,
        //date: new Date().toISOString().substr(0, 10),
        date: null,
        menu1: false,
        menu2: false,
        //date_of_birth_in_words: {},
        bloodgroup: {},
        category: {},
        religion: {},
        cast: {},
        sub_caste: {},
        ration_card_color: {},
        mothertoungue: {},
        second_language_currently_studying: {},
        languages_known: {},
        language_known_selected: [],
        aadhar_no: {},
        pen_no: {},
        saral_id: {},
        name_as_aadhar_card: {},
        udise_national_code: {},
        passport_no: {},
        specific_qualities: {},
        academic_program_studied: {},
        significant_information: {},
        citizenship: {},
        sibling_details: {},
        domacile: {},
        isphysicallyhandicapped: {},
        is_cast_certificate_available: {},
        is_bpl_beneficiary: {},
        minority: {},
        is_single_girl_child: {},
        is_EWS: {},
        physicallyhandicapped_details: {},
        medical_problem: {},
        distance_from_school_to_home_in_km: {},
        special_education_needs: {},
        height_in_cm: {},
        weight_in_kg: {},
        entrance_exam_marks: {},
        age_on_first_june: {},
        interested_in_sports: {},
        hostel: {},
        factors_contributed_for_admission_decision: {},
        is_orphan: {},
        eligibility_no: {},
        socialwelfare:{},
        is_social_welfare_required:{},
        marital_status:{},
        is_allotment_standard:"",
        //
        age_criterias: [],
        age_criteria_flag: false,
        tenant: null,
        reference: {},
        unicode_student_name: {
          field_value: ""
        },
        is_unicode_note: "",
        student_fullname:""
      };
    },
    computed: {
      formattedDate() {
        if (!this.date_of_birth.field_value) return "";
        const [year, month, day] = this.date_of_birth.field_value.split("-");
        return `${day}-${month}-${year}`;
      }
    },
    methods: {
   async convertFullNameToUnicode(){
      var first  = (this.firstname && this.firstname.field_value) ? this.firstname.field_value : ''
      var middle = (this.middlename && this.middlename.field_value) ? this.middlename.field_value : ''
      var last   = (this.lastname && this.lastname.field_value) ? this.lastname.field_value : ''

      var fullName = (first + ' ' + middle + ' ' + last).trim()

      if(!fullName){
        if(this.unicode_student_name){
          this.unicode_student_name.field_value = ''
        }
        return
      }

      const res = await fetch(
        "https://inputtools.google.com/request?text=" +
        encodeURIComponent(fullName) +
        "&itc=mr-t-i0-und&num=1"
      )

      const data = await res.json()

      if(data[0] === "SUCCESS"){
        this.unicode_student_name.field_value = data[1][0][1][0]
      }

    }, 
    async generateBirthTalukaUnicode(){

      var taluka = (this.birthtaluka && this.birthtaluka.field_value) ? this.birthtaluka.field_value : ''

      if(!taluka){
        if(this.unicodebirthtaluka){
          this.unicodebirthtaluka.field_value = ''
        }
        return
      }

      const res = await fetch(
        "https://inputtools.google.com/request?text=" +
        encodeURIComponent(taluka) +
        "&itc=mr-t-i0-und&num=1"
      )

      const data = await res.json()

      if(data[0] === "SUCCESS"){
        if(this.unicodebirthtaluka){
          this.unicodebirthtaluka.field_value = data[1][0][1][0]
        }
      }

    },
    async convertToUnicode(sourceField, targetField){

      if(!sourceField || !targetField) return

      var text = sourceField.field_value ? sourceField.field_value : ''

      if(!text){
        targetField.field_value = ''
        return
      }

      const res = await fetch(
        "https://inputtools.google.com/request?text=" +
        encodeURIComponent(text) +
        "&itc=mr-t-i0-und&num=1"
      )

      const data = await res.json()

      if(data[0] === "SUCCESS"){
        targetField.field_value = data[1][0][1][0]
      }

    },
      // openDatePicker() {
      //   // Opens the hidden date picker when clicking anywhere in the field
      //   // this.$refs.realDateInput.showPicker();
      //   const input = this.$refs.realDateInput;
      //   if (input) {
      //     input.focus();

      //     try {
      //       input.showPicker();
      //     } catch (e) {
      //       input.click();
      //     }
      //   }
      // },
        openDatePicker() {
        const input = this.$refs.realDateInput;

        if (!input) {
          return;
        }

        try {
          if (typeof input.showPicker === 'function') {
            input.showPicker();
          } else {
            input.click();
          }
        } catch (e) {
          input.click();
        }
      },
      convertDateToWords() {
        if (this.date_of_birth.field_value) {
          const dateObj = new Date(this.date_of_birth.field_value);

          if (!isNaN(dateObj)) {
            const day = dateObj.getDate();
            const month = dateObj.toLocaleString("en-US", { month: "long" });
            const year = dateObj.getFullYear();

            // Convert day and year correctly
            this.date_of_birth_in_words.field_value =
              `${this.toOrdinalWords(day)} ${month} ${this.convertYearToWords(year)}`;
          }
        }
      },
      // Convert day numbers to **ordinal words**
      toOrdinalWords(n) {
        const ordinals = {
          1: "First", 2: "Second", 3: "Third", 4: "Fourth", 5: "Fifth",
          6: "Sixth", 7: "Seventh", 8: "Eighth", 9: "Ninth", 10: "Tenth",
          11: "Eleventh", 12: "Twelfth", 13: "Thirteenth", 14: "Fourteenth",
          15: "Fifteenth", 16: "Sixteenth", 17: "Seventeenth", 18: "Eighteenth", 19: "Nineteenth",
          20: "Twentieth", 21: "Twenty First", 22: "Twenty Second", 23: "Twenty Third",
          24: "Twenty Fourth", 25: "Twenty Fifth", 26: "Twenty Sixth", 27: "Twenty Seventh",
          28: "Twenty Eighth", 29: "Twenty Ninth", 30: "Thirtieth", 31: "Thirty First"
        };

        return ordinals[n] || "";
      },
      // Convert year numbers to words correctly
      convertYearToWords(year) {
        if (year < 2000) {
          const firstPart = Math.floor(year / 100);
          const secondPart = year % 100;

          let firstPartWord = firstPart === 19 ? "Nineteen" : this.toWords(firstPart) + " Hundred";
          let secondPartWord = secondPart ? this.toWords(secondPart) : "";

          return `${firstPartWord} ${secondPartWord}`.trim();
        }

        if (year === 2000) return "Two Thousand";

        const firstPart = "Two Thousand";
        const secondPart = year % 100;

        return `${firstPart} ${secondPart ? this.toWords(secondPart) : ""}`.trim();
      },
      // Convert numbers to words
      toWords(n) {
        const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
        const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
        const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

        if (n < 10) return ones[n];
        if (n < 20) return teens[n - 10];
        if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
        return "";
      },
      // convertDateToWords() {
      //   if (this.date_of_birth.field_value) {
      //     const dateObj = new Date(this.date_of_birth.field_value);
      //     if (!isNaN(dateObj)) {
      //       const options = { day: "numeric", month: "long", year: "numeric" };
      //       this.date_of_birth_in_words.field_value = dateObj.toLocaleDateString(
      //         "en-US",
      //         options
      //       );
      //     }
      //   }
      // },
      updateRequiredFields() {
        this.aadhar_no.required = this.idType === 'aadhar';
        this.passport_no.required = this.idType === 'passport';
        this.aadhar_no.field_value = this.idType !== 'aadhar' ? '' : this.aadhar_no.field_value;
        this.passport_no.field_value = this.idType !== 'passport' ? '' : this.passport_no.field_value;
      },
      submit: function (e) {
        this.loader = false;
        var form = document.getElementById("profile_form");
        var formData = new FormData(form);
        axios.post("/admissionForm/savePersonal", formData)
          .then(
            response => {
              // success callback
              // this.form_progress = response.data.form_progress
              if (response.data.form_saved == "YES") {
                this.loader = true;
                localStorage.setItem("standardName", response.data.standardName);
                this.$emit("standardUpdated", response.data.standardName); // Emit Event
                this.showSnackbar("#4caf50", 'Saved Successfully...Click on Next Tab To Continue'); // show snackbar on success
              } else {
                this.loader = true;
                this.showSnackbar(
                  "red",
                  response.data.snackbar
                ); // show snackbar on success
                return
              }
              this.$store.commit("setform_progress", response.data.form_progress);
            },
            response => {
              // error callback
            }
          )
          .catch((error) => {
            console.log(error)
            this.loader = true;
            this.showSnackbar(
              "red",
              'something went wrong!!!'
            ); // show snackbar on success
          });
      },
      getform() {
        axios
          .post("/admissionForm/personal", this.application_form_data)
          .then(res => {
            if (res.data.msg == "200") {
              this.loader = true;
              this.firstname = res.data.firstname;
              this.lastname = res.data.lastname;
              this.middlename = res.data.middlename;
              this.mother_first_name = res.data.mother_first_name;
              this.father_full_name = res.data.father_full_name;
              this.gender = res.data.gender;
              this.shift = res.data.shift;
              this.mediumofinstruction = res.data.mediumofinstruction;
              this.standard = res.data.standard;
              this.family_income = res.data.family_income;
              this.birth_place = res.data.birth_place;
              this.birth_address = res.data.birth_address;
              this.birthcountry = res.data.birthcountry;
              this.birthcity = res.data.birthcity;
              this.birthstate = res.data.birthstate;

              this.birthdistrict = res.data.birthdistrict;
              this.birthtaluka = res.data.birthtaluka;
              this.unicodebirthtaluka = res.data.unicodebirthtaluka;
              this.unicode_birth_place = res.data.unicode_birth_place;

              this.family_type = res.data.family_type;
              this.nationality = res.data.nationality;
              this.date_of_birth = res.data.date_of_birth;
              this.date_of_birth_in_words = res.data.date_of_birth_in_words;
              this.bloodgroup = res.data.bloodgroup;
              this.category = res.data.category;
              this.religion = res.data.religion;
              this.cast = res.data.cast;
              this.sub_caste = res.data.sub_caste;
              this.ration_card_color = res.data.ration_card_color;
              this.mothertoungue = res.data.mothertoungue;
              this.second_language_currently_studying = res.data.second_language_currently_studying;
              this.languages_known = res.data.languages_known
              this.aadhar_no = res.data.aadhar_no;
              this.pen_no = res.data.pen_no;
              this.saral_id = res.data.saral_id;
              this.name_as_aadhar_card = res.data.name_as_aadhar_card;
              this.udise_national_code = res.data.udise_national_code;
              this.passport_no = res.data.passport_no;
              this.specific_qualities = res.data.specific_qualities;
              this.academic_program_studied = res.data.academic_program_studied;
              this.significant_information = res.data.significant_information;
              this.citizenship = res.data.citizenship;
              this.sibling_details = res.data.sibling_details;
              this.domacile = res.data.domacile;
              this.isphysicallyhandicapped = res.data.isphysicallyhandicapped;
              this.is_cast_certificate_available = res.data.is_cast_certificate_available;
              this.is_bpl_beneficiary = res.data.is_bpl_beneficiary;
              this.minority = res.data.minority;
              this.physicallyhandicapped_details = res.data.physicallyhandicapped_details;
              this.medical_problem = res.data.medical_problem;
              this.medication = res.data.medication;
              this.allergy = res.data.allergy;
              this.distance_from_school_to_home_in_km = res.data.distance_from_school_to_home_in_km;

              this.application_form_no = res.data.application_form_no;
              this.is_single_girl_child = res.data.is_single_girl_child;
              this.is_EWS = res.data.is_EWS;
              this.age_criterias = res.data.age_criterias
              this.special_education_needs = res.data.special_education_needs;
              this.height_in_cm = res.data.height_in_cm;
              this.weight_in_kg = res.data.weight_in_kg;
              this.reference = res.data.reference;
              this.entrance_exam_marks = res.data.entrance_exam_marks;
              this.age_on_first_june = res.data.age_on_first_june;
              this.interested_in_sports = res.data.interested_in_sports;
              this.hostel = res.data.hostel;
              this.factors_contributed_for_admission_decision = res.data.factors_contributed_for_admission_decision;

              this.unicode_student_name = res.data.unicode_student_name;
              this.is_orphan = res.data.is_orphan;
              this.eligibility_no = res.data.eligibility_no;
              this.is_social_welfare_required = res.data.is_scholarship_required;
              this.socialwelfare = res.data.scholarship;   
              this.marital_status = res.data.marital_status;
              this.is_allotment_standard = res.data.is_allotment_standard;
              this.student_fullname = res.data.student_fullname;
              this.$store.commit("setform_progress", res.data.form_progress);
              this.isNRIStudent = res.data.isNRIStudent;
              if (this.isNRIStudent == true || this.isNRIStudent == 'true') {
                this.idType = 'passport'
              } else {
                this.idType = 'aadhar'
              }
              //this.form_progress = res.data.form_progress
            }
          })
          .catch(error => {
            window.console.log(error);
          });
      },

      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
      },
      parseDate(date) {
        if (!date) return null;
        const [month, day, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      },
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      }
    },
    mounted() {
      this.is_unicode_note = localStorage.getItem("is_unicode_note");
      this.application_form_data = this.$store.getters.application_form_data;
      this.getform();
      const isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

      if (isIOS) {
        document.body.classList.add('ios-device');
      }
    },
    created() {
      this.tenant = localStorage.getItem("EPS-tenant");
    },
    watch: {
      // date(val) {
      //     this.date_of_birth.field_value = this.formatDate(this.date);
      // }
    },

  };
</script>
<style>
/* Normal Web / Desktop */
/* iPhone / iPad only */
.ios-device .date-field-wrapper {
  position: relative;
}

.ios-device .ios-date-input {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 56px;

  opacity: 0;

  z-index: 10;

  border: 0;
  padding: 0;
  margin: 0;

  cursor: pointer;
}
</style>